const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"29e1d75bac5114cfb74f810dc5fbf6c33f72e8e7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"29e1d75bac5114cfb74f810dc5fbf6c33f72e8e7"};
      